import * as React from 'react';
import { useSelector } from 'react-redux';
import { IconCommunicationPhone16 } from '@cian/ui-kit-design-tokens/icons';

import { trackShowPhoneInBannerClick } from '../../../analytics/promos';
import { PromosBanner as PromosBannerComponent } from '../../../components/PromosBanner';
import { getGaLabel } from '../../../selectors/analytics';
import { getBuilders } from '../../../selectors/newbuilding';
import { CallButtonContainer } from '../../CallButton';

const CALL_BUTTON_STYLES = {
  size: 'XS' as const,
  theme: 'fill_secondary' as const,
  beforeIcon: <IconCommunicationPhone16 color="icon-main-default" />,
};

export const PromosBanner: React.FC = () => {
  const gaLabel = useSelector(getGaLabel);
  const builders = useSelector(getBuilders);

  const isBuildersWithPhones = builders.filter(builder => builder.phone?.number && builder.showPhone).length > 0;

  const trackShowPhone = React.useCallback(() => {
    trackShowPhoneInBannerClick(gaLabel);
  }, [gaLabel]);

  return (
    <PromosBannerComponent
      isBuilder={isBuildersWithPhones}
      contactsButton={
        <CallButtonContainer
          placeType="promosBanner"
          onShowPhoneClick={trackShowPhone}
          openContactsStyles={CALL_BUTTON_STYLES}
          showPhoneStyles={CALL_BUTTON_STYLES}
          SinglePhoneComponent={null}
          singlePhoneButtonText="Показать телефон"
          multiplePhoneButtonText={isBuildersWithPhones ? 'Контакты застройщика' : 'Контакты продавца'}
        />
      }
    />
  );
};
